import { VariableBenefitDestinationJurisdictionDetail } from './variable-benefit-destination-jurisdiction-detail';
import { Deserializable } from '../protocols/deserializable';
import { SpousalWaiverAttachment } from './spousal-waiver-attachment';

export class VariableBenefitGoverningJurisdictionDetail
  extends VariableBenefitDestinationJurisdictionDetail
  implements Deserializable
{
  public spousalWaivers: SpousalWaiverAttachment[] = [];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    super.onDeserialize();
    if (this.spousalWaivers) {
      this.spousalWaivers = Deserialize.arrayOf(SpousalWaiverAttachment, this.spousalWaivers);
    }
  }
}
